import { render, staticRenderFns } from "./AddKeywordModal.vue?vue&type=template&id=7541fb1c"
import script from "./AddKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddKeywordModal.vue?vue&type=script&lang=js"
import style0 from "./AddKeywordModal.vue?vue&type=style&index=0&id=7541fb1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports